import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useCancelAgencyUploadedFileById } from '@nxsys/hooks/api/import';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { showMessage } from '@nxsys/utils/message';
import { Form, Input } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';

type CancelUploadedFileModalProps = {
  isOpen: boolean;
  toggle: () => void;
  fileId?: number;
  refetchData: () => void;
};

type CancelUploadedFileValues = {
  reason: string;
};

const CancelUploadedFileModal: React.FC<CancelUploadedFileModalProps> = ({
  isOpen,
  toggle,
  fileId,
  refetchData,
}) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm<CancelUploadedFileValues>();

  const {
    run: cancelAgencyUploadedFile,
    loading: cancelAgencyUploadedFileLoading,
  } = useCancelAgencyUploadedFileById();

  const onFinish: FormProps['onFinish'] = (values) => {
    if (!fileId) return;
    cancelAgencyUploadedFile(fileId, { reason: values.reason }).then(() => {
      showMessage({
        type: 'success',
        content: messages['common.cancelAgencyUploadFileSuccess'],
      });
      toggle();
      refetchData();
    });
  };

  return (
    <AppModalContainer
      isOpen={isOpen}
      toggle={toggle}
      title={messages['common.cancelAgencyUploadFile']}
      minHeight="200px"
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.submit'],
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: cancelAgencyUploadedFileLoading,
          disabled: cancelAgencyUploadedFileLoading,
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        <Form.Item
          name="reason"
          label={messages['common.reason']}
          rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
        >
          <Input.TextArea placeholder={messages['form.enter']} rows={6} />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default CancelUploadedFileModal;
